import { Box, Button } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { approveRejectMultipleCG, approveRejectMultiplePG, getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";

export default function ButtonGroup() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.cgpgApproval);

   const {
      selectedRows,
      selectedView,
      productGroups,
      customerGroups,

      selectedCountryID,
      selectedGroupStatus,
      selectedPeriod,
   } = state;  


   function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));

		const obj = {
			logedUser: JSON.parse(localStorage.getItem("data")),
			countryId: selectedCountryID,
			groupStatus: selectedGroupStatus,
			period: selectedPeriod,
			searchText: "",
		};

		if (selectedView === "Product Group") {
			dispatch(getProductGroups(obj));
		} else {
			dispatch(getCustomerGroups(obj));
		}
	}

   function approveSelected() {
      let itemList = [];
      for (let i = 0; i < selectedRows.length; ++i) {
         const id = selectedRows[i];

         let item = null;
         if(selectedView === "Product Group") {
            item = productGroups.find((pg) => pg.productGroupID === id);
         }
         else {
            item = customerGroups.find((cg) => cg.customerGroupID === id);
         }
         item = {
            ...item,
            isApprove: 1,
         };
         itemList.push(item);
      }
      console.log("Approve_CGPG_ApproveRejectSelected", itemList);

      if(selectedView === "Product Group") {
         dispatch(approveRejectMultiplePG(itemList));
      }
      else {
         dispatch(approveRejectMultipleCG(itemList));
      }
      search();
   }

   function openRejectionModal() {
      dispatch(setState("rejectMultiModalOpen", true));
   }

   return (
      <Box>
         <Box
            sx={{
               mt: 2,
               display: "flex",
               flexDirection: "row",
               justifyContent: "flex-start",
            }}
         >
            <Button
               sx={{
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  ml: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
               disabled={selectedRows.length === 0}
               onClick={approveSelected}
            >
               Approve Selected
            </Button>

            <Button
               sx={{
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  ml: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
               disabled={selectedRows.length === 0}
               onClick={openRejectionModal}
            >
               Reject Selected
            </Button>
         </Box>
      </Box>
   );
}
